import { useCallback, useState } from 'react'
import { fetchDocumentSignedUrl } from '@/lib/api'

interface State {
    loading: boolean
    error: string | null
}

// MLRO clicks an evidence link — we fetch a short-lived signed URL on demand
// and open it in a new tab. Never hard-link to the underlying Sumsub asset.
export function useOpenSignedDocument() {
    const [state, setState] = useState<State>({ loading: false, error: null })

    const open = useCallback(async (documentId: string) => {
        setState({ loading: true, error: null })
        try {
            const res = await fetchDocumentSignedUrl(documentId)
            window.open(res.url, '_blank', 'noopener,noreferrer')
            setState({ loading: false, error: null })
        } catch (err) {
            setState({
                loading: false,
                error: err instanceof Error ? err.message : 'Failed to open document',
            })
        }
    }, [])

    return { ...state, open }
}
